(function () {
  let swiper;

  function init() {
    swiper = new Swiper('.bi-featured-products .swiper', {
      slidesPerView: 2.4,
      slidesPerGroup: 2,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      lazyPreloadPrevNext: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        560: {
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          slidesPerView: 3.2,
          slidesPerGroup: 3,
        },
        750: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        960: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerView: 4,
          slidesPerGroup: 4,
          navigation: {
            prevEl: '.bi-featured-products .swiper-button-prev',
            nextEl: '.bi-featured-products .swiper-button-next',
          },
        },
      },
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (e) => {
    if (!e.target.classList.contains('bi-featured-products__item')) return;

    const slides = document.querySelectorAll('.bi-featured-products__list li');

    slides?.forEach((currentSlide, currentIndex) => {
      if (e.target === currentSlide) {
        swiper.slideTo(currentIndex);
      }
    });
  });
})();
